// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-94516a6c]{width:100%;display:flex;justify-content:center;align-items:center;height:auto}svg[data-v-94516a6c]{margin-top:60px;height:auto;width:98%}@media (min-width:600px){svg[data-v-94516a6c]{width:70%}}@media (min-width:1440px){.wrapper[data-v-94516a6c]{height:500px}svg[data-v-94516a6c]{height:530px;left:0}}.illustration-and-message[data-v-94516a6c]{max-width:1185px}.content-wrapper-crtified[data-v-94516a6c]{min-height:300px}", ""]);
// Exports
module.exports = exports;
